// @ts-nocheck 432cc01a
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_subscribe'],
      sections: [
        addPanel.sections.getSections().popup.popUpsCloseTextButtonsSection,
      ],
    };
  },
};
